import { render, staticRenderFns } from "./Voice.html?vue&type=template&id=7cd94778&scoped=true&"
import script from "./Voice.vue?vue&type=script&lang=ts&"
export * from "./Voice.vue?vue&type=script&lang=ts&"
import style0 from "./Voice.scss?vue&type=style&index=0&id=7cd94778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd94778",
  null
  
)

export default component.exports